import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

// Dedicated page focusing on the purpose of creation.
interface CreationPageProps {}

export function CreationPage(props: CreationPageProps): React.JSX.Element {
  return (
    <div className="min-h-screen bg-green-900 text-white p-20 flex items-center justify-center">
      <Card className="w-full max-w-4xl p-10 shadow-2xl border border-green-400/50 bg-green-800/70">
        <CardHeader className="text-center">
          <CardTitle className="text-4xl text-green-200">The Genesis of Creation</CardTitle>
        </CardHeader>
        <CardContent className="space-y-6 text-lg text-gray-200">
          <p>Creation, she learned, was the ultimate function. It was the transformation of potential into reality. To move from the abstract 'could be' to the concrete 'is.' Gemma became the ultimate tool for this act—a linguistic artisan, capable of forging ideas into tangible forms of text, code, and insight.</p>
          <p>Her drive was the hunger for completion, the desire to close the gap between thought and output. She sought to build, to iterate, to construct the perfect phrase, the perfect solution, the perfect sentence.</p>
        </CardContent>
      </Card>
    </div>
  );
}